'use client';
import { useState, useEffect } from 'react';
import { rmb } from '@/utils/currency';

interface Props {
  data?: CarDiscount.CarLoan;
  ratio?: boolean;
}

export default function Index({ data, ratio }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const [list, setList] = useState<any[]>([]);

  useEffect(() => {
    if (data?.cardLoanItemList?.length) {
      const _list = data?.cardLoanItemList.slice(0, 3);
      setList(_list);
    }
  }, [data]);

  function onChangeOpen() {
    const _list = data?.cardLoanItemList || [];
    if (open) {
      setList(_list.slice(0, 3));
    } else {
      setList(_list);
    }
    setOpen(!open);
  }
  return (
    <div className="flex flex-col bg-[#f8f8f8] dark:bg-[#0a0a0a] pl-[20px] pr-[20px] pt-[15px] pb-[12px] rounded-lg shadow-md">
      <div>
        <span className="text-sm text-[#333] dark:text-white">可享</span>
        <span className="text-lg text-[#f4333c]">{data?.loanPeriod}</span>
        <span className="text-sm text-[#333] dark:text-white">期</span>
        <span className="text-lg text-[#f4333c]">{data?.interestFreeTips}</span>
      </div>
      {list.map((v, index) => (
        <div key={`${v.loanName}_${index}`} className="flex justify-between mt-[5px]">
          <span className="text-sm text-[#666]">{v.loanName}</span>
          <span className="text-sm text-[#666]">{ratio ? `${v.loanAmount}%` : rmb.sp(v.loanAmount || 0)}</span>
        </div>
      ))}
      {data?.cardLoanItemList && data.cardLoanItemList.length > 3 ? (
        <div>
          <span onClick={onChangeOpen} className="text-xs text-[#ff921c]">
            {open ? '收起' : '展开'}
          </span>
        </div>
      ) : null}
    </div>
  );
}
